export default __webpack_public_path__ + "static/media/new-icon.0d704075.svg";